<template>
  <cp-general-modal
    id="create-issuer"
    ref="createIssuerModal"
    title-icon="ios-person-add"
    :title="$t('component.createIssuerModal.title')"
    :ok-text="$t('common.button.save')"
    :cancel-text="$t('common.button.close')"
    @onOk="handleSubmit"
  >
    <cp-input
      v-model.trim="newIssuer.issuerName"
      name="issuerName"
      :label="$t('component.createIssuerModal.input.issuerName')"
      validate="required|min:3|max:50"
    />
    <cp-input
      v-model.trim="newIssuer.tokenName"
      name="tokenName"
      :label="$t('component.createIssuerModal.input.tokenName')"
      validate="required|min:3|max:50"
    />
    <cp-select
      v-model="newIssuer.blockchain"
      :options="blockchainOptions"
      name="blockchain"
    />
  </cp-general-modal>
</template>

<script>
import CpGeneralModal from '~/components/common/modals-components/general-modal';
import CpSelect from '~/components/common/standalone-components/inputs/cp-select';
import CpInput from '~/components/common/standalone-components/inputs/cp-input';

export default {
  name: 'CreateIssuerModal',
  components: {
    CpGeneralModal,
    CpInput,
    CpSelect,
  },
  data() {
    return {
      newIssuer: {
        blockchain: 'ethereum',
      },
      blockchainOptions: [
        { text: this.$t('common.blockchain.ethereum'), value: 'ethereum' },
        { text: this.$t('common.blockchain.tezos'), value: 'tezos' },
        { text: this.$t('common.blockchain.algorand'), value: 'algorand' },
      ],
    };
  },
  methods: {
    handleSubmit() {
      this.$emit('onCreateIssuer', this.newIssuer);
      this.$refs.createIssuerModal.hide();
    },
  },
};
</script>
